import React, { Component } from 'react'
import { FaFilter } from 'react-icons/fa'
import {
  styled,
  Checkbox,
  Button,
  updateContextState,
  context,
  connectRequest,
  productRequests,
} from '@tools/wr-catalog-base'
import { trackPageAction } from '@utils/tracking'
import DropdownInput from './dropdown-input'

const OptionWrapper = styled.div`
  padding: 15px;
`

const DropdownWrapper = styled.div`
  z-index: 9;
  .filters__control {
    visibility: hidden;
    position: absolute;
  }

  div.dropdown-input {
    margin-top: 0;
  }

  .filters__menu {
    width: 350px;
    right: 0;
  }
`

const Badge = styled.div`
  position: absolute;
  top: 0;
  right: 1rem;
  transform: translateY(-50%);
`

const StyledBadge = styled(Badge)`
  right: 0;
  background-color: #fff;
  border: 1px solid ${({ theme }) => theme.palette.primary};
  color: ${({ theme }) => theme.palette.primary};
  padding: 3px 7px;
  font-size: 0.75rem;
  border-radius: 5px;
  transform: translateY(-50%) translateX(50%);
`

const DefaultTriggerButton = (props) => {
  const { onClick, countBadge } = props

  return (
    <Button
      primary
      onClick={(...args) => {
        trackPageAction('click', 'main-page-control', 'Choose Region')
        onClick(...args)
      }}
    >
      <FaFilter />
      {countBadge}
    </Button>
  )
}

function Option(props) {
  props.theme.colors.primary = 'transparent'

  return (
    <OptionWrapper
      key={props.data.value}
      isSelected={props.isSelected}
      onClick={() => {
        trackPageAction('checkbox', 'region', props.data.value)
        props.selectOption(props.data.value)
      }}
    >
      <Checkbox type="checkbox" checked={props.isSelected} onChange={() => null} /> <label>{props.data.value}</label>
    </OptionWrapper>
  )
}
class FiltersDropdown extends Component {
  isFocused = false

  componentDidMount() {
    this.updateRegions()
  }

  componentDidUpdate() {
    this.updateRegions()
  }

  updateRegions = () => {
    const {
      allRegions,
      catalogs: [{ contents: { items } = {} } = {}],
    } = context.state

    // Only compute once per items list; otherwise a catalog without regions
    // would update the context on every componentDidUpdate and loop forever
    if (!allRegions.length && items && this.regionsSourceItems !== items) {
      this.regionsSourceItems = items

      const regions = new Set()
      items.forEach((item) => {
        const pricingRow = (item.rows || []).find((r) => r.rowType === 'component:pricing')
        const constants = pricingRow?.control?.constants
        if (!constants) return

        constants.forEach((con) => regions.add(con.name))
      })

      if (!regions.size) return

      updateContextState((state) => {
        state.allRegions = [...regions].sort()
        const savedRegion = localStorage.getItem('selectedRegion')
        state.selectedRegion =
          state.allRegions.find((r) => r === savedRegion) ||
          state.allRegions.find((r) => r.toLowerCase().includes('america'))
      })
    }
  }

  triggerSelect = () => {
    if (this.isFocused) {
      document.querySelector('.filters__input input').blur()
    } else {
      document.querySelector('.filters__indicator').click()
    }
  }

  handleFiltersChange = (value) => {
    updateContextState((state) => {
      state.selectedRegion = value
      localStorage.setItem('selectedRegion', value)
    })
  }

  onMenuOpen = () => {
    this.isFocused = true
  }

  onMenuClose = () => {
    setTimeout(() => {
      this.isFocused = false
    }, 200)
  }

  render() {
    const options = context.state.allRegions.map((r) => ({ value: r }))
    const filtersSelected = 1
    const value = [{ value: context.state.selectedRegion }]
    const TriggerButton =
      context.theme.components.productList.toolbar.filtersDropdown.buttonComponent || DefaultTriggerButton

    return (
      <>
        <TriggerButton
          onClick={this.triggerSelect}
          type="button"
          selectedFiltersCount={filtersSelected}
          countBadge={filtersSelected > 0 && <StyledBadge>{filtersSelected}</StyledBadge>}
          {...this.props.buttonProps}
        />
        <DropdownWrapper>
          <DropdownInput
            value={value}
            onChange={this.handleFiltersChange}
            getSelectRef={this.getSelectRef}
            onMenuClose={this.onMenuClose}
            onMenuOpen={this.onMenuOpen}
            options={options}
            closeMenuOnSelect={false}
            hideSelectedOptions={false}
            className="filters"
            classNamePrefix="filters"
            components={{ Option }}
            large
            fullWidth
          />
        </DropdownWrapper>
      </>
    )
  }
}

export default connectRequest(() => ({
  catalogFetch: productRequests.fetchProductsByCatalogId(context.state.selectedCatalogId),
}))(FiltersDropdown)
